// extracted by mini-css-extract-plugin
export default {"zoomModal":"i2-z"};